import { IcoArrowLeft, IcoClose } from "assets/icons";
import { BaseModal, Button, ModalFooter, TextArea } from "components";
import { ErrorHelper } from "helpers";
import { useIsMobile } from "hooks/useIsMobile";
import { ChangeEvent, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { ApplicationService } from "services/applicationService";

type Props = {
	applicationId: string;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
};

export default function RejectCancellationModal({ applicationId, isOpen, onClose, onSuccess }: Props) {
	const isMobile = useIsMobile();
	const applicationService = useMemo(ApplicationService.getInstance, []);
	const [reason, setReason] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(false);

	const handleConfirm = async () => {
		if (!reason || reason.trim().length < 10) {
			toast.warning("Informe o motivo da rejeição (mínimo 10 caracteres)");
			return;
		}

		setLoading(true);
		try {
			await applicationService.rejectCancellation(applicationId, reason);
			toast.success("Cancelamento rejeitado com sucesso");
			onClose();
			onSuccess?.();
		} catch (error) {
			toast.error(ErrorHelper.getResponseErrorMessage(error));
		} finally {
			setLoading(false);
		}
	};

	return (
		<BaseModal onClickOutsideModal={onClose} isOpen={isOpen} contentClassName="rounded-xl overflow-hidden" bodyClassName="!px-6 !py-6 !gap-4">
			{isMobile && (
				<div className="flex justify-start px-6 py-2 border-b-2 border-neutral-high-100">
					<button onClick={onClose} aria-label="voltar">
						<IcoArrowLeft size="24" />
					</button>
				</div>
			)}

			<div className="flex justify-between items-center px-1">
				<div className="font-heading-semibold-tiny">Rejeitar cancelamento</div>
				{!isMobile && (
					<Button kind="icon" hierarchy="ghost" onClick={onClose}>
						<IcoClose />
					</Button>
				)}
			</div>

			<div className="flex flex-col gap-6 px-1 overflow-y-auto">
				<div className="font-neutral-low-400">O status da solicitação retornará para APROVADO. Informe o motivo da rejeição.</div>

				<TextArea
					label="Motivo da rejeição"
					placeholder="Digite o motivo..."
					value={reason}
					onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setReason(e.target.value)}
					maxLength={300}
					required
					showIncreasingCharCount
					touched
				/>

				<ModalFooter>
					<Button hierarchy="secondary" size="medium" onClick={onClose}>
						Cancelar
					</Button>
					<Button
						hierarchy="primary"
						size="medium"
						onClick={handleConfirm}
						disabled={!reason || reason.trim().length < 10}
						isLoading={loading}
					>
						Rejeitar
					</Button>
				</ModalFooter>
			</div>
		</BaseModal>
	);
}
